let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("11VQT")).then(() => parcelRequire('1ElO6'));